module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "nav-out-wrapper"
  }, [_c('div', {
    staticClass: "nav-title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "a-plus-logo.png?v=3.0")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-wrapper"
  }, [_c('router-link', {
    class: {
      'current': _vm.tempCurrent === 0
    },
    attrs: {
      "to": {
        name: '/'
      }
    },
    nativeOn: {
      "mouseout": function($event) {
        _vm.tempCurrent = _vm.currentPage
      },
      "mouseover": function($event) {
        _vm.setTempCurrent(0)
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('router-link', {
    class: {
      'current': _vm.tempCurrent === 1
    },
    attrs: {
      "to": {
        name: 'copyrighterIndex'
      }
    },
    nativeOn: {
      "mouseout": function($event) {
        _vm.tempCurrent = _vm.currentPage
      },
      "mouseover": function($event) {
        _vm.setTempCurrent(1)
      }
    }
  }, [_vm._v("我有作品")]), _vm._v(" "), (_vm.$store.state.user.isOperator) ? _c('a', {
    class: {
      'current': _vm.tempCurrent === 3
    },
    attrs: {
      "href": "/personalcenter/todo"
    },
    on: {
      "mouseout": function($event) {
        _vm.tempCurrent = _vm.currentPage
      },
      "mouseover": function($event) {
        _vm.setTempCurrent(3)
      }
    }
  }, [_vm._v("我是运营")]) : _c('router-link', {
    class: {
      'current': _vm.tempCurrent === 2
    },
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    },
    nativeOn: {
      "mouseout": function($event) {
        _vm.tempCurrent = _vm.currentPage
      },
      "mouseover": function($event) {
        _vm.setTempCurrent(2)
      }
    }
  }, [_vm._v("我有好声音")])], 1)], 1), _vm._v(" "), (_vm.$store.state.user.name) ? _c('el-popover', {
    ref: "userpop",
    attrs: {
      "popper-class": "pop-user",
      "placement": "bottom",
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "pop-zone"
  }, [_c('a', {
    staticClass: "pop-item",
    on: {
      "click": _vm.toCopyrightCenter
    }
  }, [_vm._v("版权方工作台")]), _vm._v(" "), (_vm.$store.state.user.isOperator) ? _c('a', {
    staticClass: "pop-item",
    attrs: {
      "href": ((_vm.$store.state.A_PC_HOST) + "/personalcenter/todo")
    }
  }, [_vm._v("运营工作台")]) : _c('a', {
    staticClass: "pop-item",
    on: {
      "click": _vm.toAnchorCenter
    }
  }, [_vm._v("主播工作台")]), _vm._v(" "), _c('a', {
    staticClass: "pop-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])]), _vm._v(" "), _c('div', {
    staticClass: "nav-tail",
    slot: "reference"
  }, [(_vm.$store.state.user.logoPic) ? _c('img', {
    attrs: {
      "src": ("" + (_vm.$store.state.UPLOAD_IMG_HOST) + (_vm.$store.state.user.logoPic))
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$store.state.user.name))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right",
    staticStyle: {
      "color": "white"
    }
  })])]) : _c('div', {
    staticClass: "nav-tail nav-tail-off"
  }, [_c('a', {
    attrs: {
      "href": _vm.$store.state.LOGIN_URL + '?fromUri=' + _vm.$store.state.HOST
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', [_vm._v(" |")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$store.state.REGISTER_URL
    }
  }, [_vm._v("注册")])])], 1), _vm._v(" "), (_vm.currentPage === 1) ? _c('div', {
    staticClass: "sub-nav-wrapper"
  }, [_c('div', {
    staticClass: "sub-nav"
  }, [_c('a', {
    class: {
      'sub-current': _vm.tempSubCurrent === 1
    },
    on: {
      "click": _vm.toCopyrightCenter
    },
    nativeOn: {
      "mouseout": function($event) {
        _vm.tempSubCurrent = _vm.currentSubPage
      },
      "mouseover": function($event) {
        _vm.setTempSubCurrent(1)
      }
    }
  }, [_vm._v("版权方工作台")]), _vm._v(" "), _c('router-link', {
    class: {
      'sub-current': _vm.tempSubCurrent === 2
    },
    attrs: {
      "to": {
        name: 'copyrighterHelpCenter'
      }
    },
    nativeOn: {
      "mouseout": function($event) {
        _vm.tempSubCurrent = _vm.currentSubPage
      },
      "mouseover": function($event) {
        _vm.setTempSubCurrent(2)
      }
    }
  }, [_vm._v("帮助中心")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentPage === 2) ? _c('div', {
    staticClass: "sub-nav-wrapper"
  }, [_c('div', {
    staticClass: "sub-nav"
  }, [(_vm.isAnchor) ? _c('router-link', {
    class: {
      'sub-current': _vm.tempSubCurrent === 3
    },
    attrs: {
      "to": {
        name: 'anchorCenter'
      }
    },
    nativeOn: {
      "mouseout": function($event) {
        _vm.tempSubCurrent = _vm.currentSubPage
      },
      "mouseover": function($event) {
        _vm.setTempSubCurrent(3)
      }
    }
  }, [_vm._v("主播工作台")]) : _c('span', [_vm._v("主播工作台")]), _vm._v(" "), _c('a', {
    class: {
      'sub-current': _vm.tempSubCurrent === 4
    },
    attrs: {
      "href": ((_vm.$store.state.A_PC_HOST) + "/requirementview")
    },
    on: {
      "mouseout": function($event) {
        _vm.tempSubCurrent = _vm.currentSubPage
      },
      "mouseover": function($event) {
        _vm.setTempSubCurrent(4)
      }
    }
  }, [_vm._v("海选任务")]), _vm._v(" "), _c('router-link', {
    class: {
      'sub-current': _vm.tempSubCurrent === 5
    },
    attrs: {
      "to": {
        name: 'anchorHelpCenter'
      }
    },
    nativeOn: {
      "mouseout": function($event) {
        _vm.tempSubCurrent = _vm.currentSubPage
      },
      "mouseover": function($event) {
        _vm.setTempSubCurrent(5)
      }
    }
  }, [_vm._v("帮助中心")])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41d252be!./~/vue-loader/lib/selector.js?type=template&index=0!./views/components/Top.vue
// module id = 328
// module chunks = 0